import React, { useMemo } from 'react';
import i18next from 'i18next';
import SimpleTableWithSorting, {
  generateColumn,
} from 'app/components/common/SimpleTableWithSorting';
import { IRestaurantCompanyWithRestaurantsAndContacts } from 'types';
import type { OriginalRestaurant } from 'types';

export interface CompanyRestaurantRow {
  id: string;
  companyId: number;
  companyName: string;
  companyNip: string | number;
  restaurantId: number;
  restaurantName: string;
}

const getColumns = () => [
  generateColumn('id', { customHeader: i18next.t('companies.pair-id') }),
  generateColumn('companyId', { customHeader: i18next.t('companies.company-id') }),
  generateColumn('companyName', { customHeader: i18next.t('companies.company-name') }),
  generateColumn('companyNip', { customHeader: i18next.t('companies.nip') }),
  generateColumn('restaurantId', { customHeader: i18next.t('companies.restaurant-id') }),
  generateColumn('restaurantName', { customHeader: i18next.t('companies.restaurant-name') }),
];

export interface CompaniesRestaurantsTableProps {
  companies: IRestaurantCompanyWithRestaurantsAndContacts[];
}

export const CompaniesRestaurantsTable: React.FC<
  CompaniesRestaurantsTableProps
> = ({ companies }) => {
  const columns = useMemo(() => getColumns(), []);
  const rows: CompanyRestaurantRow[] = useMemo(() => {
    const result: CompanyRestaurantRow[] = [];
    (companies || []).forEach((company) => {
      (company.restaurants || []).forEach((restaurant: OriginalRestaurant) => {
        result.push({
          id: `${company.id}-${restaurant.id}`,
          companyId: company.id,
          companyName: company.name,
          companyNip: company.nip,
          restaurantId: restaurant.id,
          restaurantName: `${restaurant.name} (${restaurant.id})`,
        });
      });
    });
    return result;
  }, [companies]);

  return (
    <SimpleTableWithSorting
      columns={columns}
      data={rows}
      hasFilters
      pageSize={50}
    />
  );
};

export default CompaniesRestaurantsTable;
